import * as validate from '@/lib/validate'

// What each Field `type` renders and the defaults it brings; a prop given on Field wins over these.
// `check` is the type's format rule, run on a filled value before its form saves.
export const PRESETS = {
  text: { input: 'TextInput' },
  email: { input: 'TextInput', icon: 'fa-regular fa-envelope', inputmode: 'email', autocomplete: 'email', check: validate.email },
  iban: { input: 'TextInput', icon: 'fa-solid fa-building-columns', autocomplete: 'off', check: validate.iban },
  vat: { input: 'TextInput', autocomplete: 'off', check: validate.vat },
  tel: { input: 'TextInput', icon: 'fa-solid fa-phone', inputmode: 'tel', autocomplete: 'tel' },
  url: { input: 'TextInput', icon: 'fa-solid fa-link', inputmode: 'url' },
  search: { input: 'TextInput', native: 'search', icon: 'fa-solid fa-magnifying-glass' },
  password: { input: 'TextInput', native: 'password', icon: 'fa-solid fa-key' },
  number: { input: 'TextInput', native: 'number', align: 'end' },
  decimal: { input: 'TextInput', inputmode: 'decimal', align: 'end' },
  price: { input: 'TextInput', icon: 'fa-solid fa-euro-sign', unit: '€', inputmode: 'decimal', align: 'end' },
  percent: { input: 'TextInput', icon: 'fa-solid fa-percent', unit: '%', inputmode: 'decimal', align: 'end' },
  color: { input: 'TextInput', native: 'color' },
  textarea: { input: 'TextArea', shape: 'area' },
  select: { input: 'SelectInput' },
  choice: { input: 'ChoiceInput', shape: 'bare' },
  date: { input: 'DateInput', icon: 'fa-regular fa-calendar' },
  checkbox: { input: 'SwitchInput', shape: 'switch' },
  upload: { input: 'UploadField', shape: 'bare' },
}

// The props each input understands; Field hands an input only its own.
export const INPUT_PROPS = {
  TextInput: ['placeholder', 'disabled', 'readonly', 'required', 'name', 'autocomplete', 'inputmode', 'min', 'max', 'step', 'maxlength', 'native', 'align'],
  TextArea: ['placeholder', 'disabled', 'readonly', 'required', 'name', 'rows', 'maxlength', 'autogrow'],
  SelectInput: ['placeholder', 'disabled', 'required', 'name', 'options', 'labelKey', 'valueKey', 'clearable', 'loading'],
  ChoiceInput: ['disabled', 'name', 'options', 'labelKey', 'valueKey'],
  DateInput: ['disabled', 'readonly', 'required', 'name', 'min', 'max'],
  SwitchInput: ['disabled', 'name', 'text'],
  UploadField: ['colorImages', 'colorOptions'],
}
